import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";


const AboutUs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "About MANET", path: "about-manet" },
    { name: "Vision & Mission", path: "vision-mission" },
    { name: "About MIT Group of Institutions", path: "mit-group" },
    { name: "Board of Bodies", path: "board-bodies" },
    { name: "From the Principal's Desk", path: "principals-desk" },
    { name: "Awards & Recognition", path: "awards" },
    { name: "Accreditations & Approvals", path: "accreditations" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name || "About MANET";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "vision-mission": {
      title: "Vision & Mission",
      bgImage: "/assets/images/inner_bnr/DPM06705.jpg",
    },
    "mit-group": {
      title: "About MIT Group of Institutions",
      bgImage: "/assets/images/inner_bnr/mit-adt.jpg",
    },
    "board-bodies": {
      title: "Board of Bodies",
      bgImage: "/assets/images/inner_bnr/aerial-view.jpg",
    },
    "principals-desk": {
      title: "From the Principal's Desk",
      bgImage: "/assets/images/inner_bnr/aerial-view.jpg",
    },
    awards: {
      title: "Awards & Recognition",
      bgImage: "/assets/images/inner_bnr/Awards_and_Recognition.jpg",
    },
    accreditations: {
      title: "Accreditations & Approvals",
      bgImage: "/assets/images/inner_bnr/aerial-view.jpg",
    },
  };

  // Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key)
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "About MANET",
        bgImage: "/assets/images/inner_bnr/About_MANET-4.jpg",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AboutUs;
